var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background}),attrs:{"id":"main"}},[_c('Navbar'),_c('v-main',[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }